<div class="p-6">

  <!-- Header: count + search -->
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-5">
    <p class="text-sm text-gray-500">
      <ng-container *ngIf="!isLoading">
        <span class="font-semibold text-gray-700">{{ filteredExhibitors.length }}</span>
        exhibitor{{ filteredExhibitors.length === 1 ? '' : 's' }} with videos
      </ng-container>
      <ng-container *ngIf="isLoading">Loading videos…</ng-container>
    </p>

    <div class="relative w-full sm:w-72">
      <input
        type="text"
        [(ngModel)]="searchValue"
        placeholder="Search exhibitor…"
        class="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 pl-9 text-sm text-gray-700 focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400"
      />
      <svg class="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="space-y-2">
    <div *ngFor="let i of [1,2,3,4,5,6]" class="h-12 animate-pulse rounded-lg bg-gray-100"></div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && filteredExhibitors.length === 0" class="rounded-xl border border-dashed border-gray-200 py-16 text-center">
    <svg class="mx-auto h-10 w-10 text-gray-300" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
    </svg>
    <p class="mt-3 text-sm text-gray-500">No exhibitor videos found.</p>
  </div>

  <!-- Table / list view -->
  <div *ngIf="!isLoading && filteredExhibitors.length > 0" class="overflow-x-auto rounded-lg border border-gray-200">
    <table class="min-w-full divide-y divide-gray-200 text-sm">
      <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="w-12 px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-500">Logo</th>
          <th scope="col" class="w-12 px-2 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-500">Photo</th>
          <th scope="col" class="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-500">Exhibitor</th>
          <th scope="col" class="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-500">Contact</th>
          <th scope="col" class="px-4 py-2.5 text-right text-xs font-medium uppercase tracking-wide text-gray-500">Videos</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 bg-white">
        <tr *ngFor="let e of filteredExhibitors; trackBy: trackByExhibitor" class="hover:bg-gray-50">
          <!-- Logo -->
          <td class="px-4 py-2">
            <div class="flex h-9 w-9 items-center justify-center overflow-hidden rounded bg-gray-50 ring-1 ring-gray-100">
              <img *ngIf="logoUrl(e)" [src]="logoUrl(e)" [alt]="displayName(e)" class="h-full w-full object-contain" />
              <svg *ngIf="!logoUrl(e)" class="h-5 w-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
              </svg>
            </div>
          </td>

          <!-- Profile photo -->
          <td class="px-2 py-2">
            <phuture-iavatar
              *ngIf="profileUrl(e)"
              [src_image]="profileUrl(e)"
              dimension="36"
              aClass="rounded-full"
            ></phuture-iavatar>
            <span *ngIf="!profileUrl(e)" class="block h-9 w-9 rounded-full bg-gray-100 ring-1 ring-gray-100"></span>
          </td>

          <!-- Name -->
          <td class="px-4 py-2">
            <span class="font-medium text-gray-800">{{ displayName(e) }}</span>
          </td>

          <!-- Contact -->
          <td class="px-4 py-2 text-gray-500">{{ contactName(e) || '—' }}</td>

          <!-- Preview buttons -->
          <td class="px-4 py-2">
            <div class="flex flex-wrap items-center justify-end gap-2">
              <button
                *ngIf="hasImageVideo(e)"
                type="button"
                (click)="openPreview(e, 'image')"
                class="inline-flex items-center gap-1.5 rounded-md bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-100"
              >
                <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
                </svg>
                Image video
              </button>

              <button
                *ngIf="hasPresentationVideo(e)"
                type="button"
                (click)="openPreview(e, 'presentation')"
                class="inline-flex items-center gap-1.5 rounded-md bg-violet-50 px-2.5 py-1 text-xs font-medium text-violet-700 transition-colors hover:bg-violet-100"
              >
                <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
                </svg>
                Presentation video
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- Video preview dialog -->
<div
  *ngIf="previewOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
  (click)="closePreview()"
>
  <div class="w-full max-w-3xl overflow-hidden rounded-xl bg-white shadow-2xl" (click)="$event.stopPropagation()">
    <!-- Dialog header -->
    <div class="flex items-center justify-between border-b border-gray-100 px-5 py-3">
      <div class="min-w-0">
        <p class="truncate text-sm font-semibold text-gray-800" [title]="previewTitle">{{ previewTitle }}</p>
        <p class="text-xs text-gray-400">{{ previewLabel }}</p>
      </div>
      <button
        type="button"
        (click)="closePreview()"
        class="ml-4 rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
        aria-label="Close preview"
      >
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Player -->
    <div class="bg-black">
      <video
        *ngIf="previewUrl"
        [src]="previewUrl"
        controls
        autoplay
        playsinline
        class="max-h-[70vh] w-full bg-black"
      >
        <source [src]="previewUrl" [type]="previewMime" />
        Your browser does not support the video tag.
      </video>
    </div>

    <!-- Dialog footer -->
    <div class="flex items-center justify-end gap-2 border-t border-gray-100 px-5 py-3">
      <a
        [href]="previewUrl"
        download
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-1.5 rounded-md bg-blue-600 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-blue-700"
      >
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
        </svg>
        Download
      </a>
      <button
        type="button"
        (click)="closePreview()"
        class="rounded-md border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-50"
      >
        Close
      </button>
    </div>
  </div>
</div>
